// Thư mục: src/services/dmHangMucBaoDuongService.js
import api from "@/api";

const BASE_URL = "/api/dm-hang-muc-bao-duong"; // Endpoint gốc

/**
 * API service cho Danh mục Hạng mục Bảo dưỡng
 */
export const DmHangMucBaoDuongApi = {
  /**
   * Lấy danh sách hạng mục (phân trang và tìm kiếm theo tên)
   * @param {object} params - { q?, page?, size?, sort? }
   * @returns {Promise<object>} Page<DmHangMucBaoDuongResponse>
   */
  search(params = { q: "", page: 0, size: 10, sort: "tenHangMuc,asc" }) {
    return api.get(BASE_URL, { params }).then((res) => res.data);
  },

  /**
   * Lấy chi tiết 1 hạng mục theo ID
   * @param {number} id - ID hạng mục
   * @returns {Promise<object>} DmHangMucBaoDuongResponse
   */
  getById(id) {
    return api.get(`${BASE_URL}/${id}`).then((res) => res.data);
  },

  /**
   * Tạo hạng mục mới
   * @param {object} payload - DmHangMucBaoDuongRequest { tenHangMuc, chuKyKm?, ghiChu?, active? }
   * @returns {Promise<object>} DmHangMucBaoDuongResponse
   */
  create(payload) {
    return api.post(BASE_URL, payload).then((res) => res.data);
  },

  /**
   * Cập nhật hạng mục
   * @param {number} id - ID hạng mục
   * @param {object} payload - DmHangMucBaoDuongRequest
   * @returns {Promise<object>} DmHangMucBaoDuongResponse
   */
  update(id, payload) {
    return api.put(`${BASE_URL}/${id}`, payload).then((res) => res.data);
  },

  /**
   * Xóa (mềm) hạng mục
   * @param {number} id - ID hạng mục
   * @returns {Promise<void>} 204 No Content
   */
  remove(id) {
    return api.delete(`${BASE_URL}/${id}`).then((res) => res.data);
  },

  /**
   * Lấy danh sách options (ID, Tên) đang active cho dropdown
   * @returns {Promise<Array<object>>} List<{ id: number, tenHangMuc: string }>
   */
  listActiveOptions() {
    return api.get(`${BASE_URL}/active-options`).then((res) => res.data);
  },
};
